import React from 'react'

import {
  FormOnChange,
  IconWrapper,
  MyOptionType,
  Select,
  SelectProps,
  Width,
} from '@procsea/design-system'

export const VISIBILITY_OPTIONS: MyOptionType<boolean>[] = [
  { label: gettext('Visible'), value: true },
  { label: gettext('Not visible'), value: false },
]

const formatVisibilityOption = ({ label, value }: MyOptionType<Boolean>) => (
  <IconWrapper icon={value ? 'eye' : 'eye-slash'}>{label}</IconWrapper>
)

export interface VisibilitySelectorProps {
  'data-e2e'?: string
  fluid?: boolean
  label?: string
  menuPortalTarget?: SelectProps<boolean, false>['menuPortalTarget']
  minWidth?: Width | null
  onChange?: FormOnChange<boolean | null>
  value?: boolean | null
}

const VisibilitySelector = ({
  'data-e2e': dataE2e = 'visibility-select',
  fluid,
  label,
  menuPortalTarget,
  minWidth = '11rem',
  onChange,
  value,
}: VisibilitySelectorProps) => (
  <Select<boolean, false>
    clearable
    data-e2e={dataE2e}
    fluid={fluid}
    formatOptionLabel={formatVisibilityOption}
    formatValueLabel={formatVisibilityOption}
    label={label}
    minWidth={minWidth}
    menuPortalTarget={menuPortalTarget}
    onChange={onChange}
    options={VISIBILITY_OPTIONS}
    placeholder={gettext('Visibility')}
    value={value ?? null}
  />
)

export default VisibilitySelector
